import {
  getPurchasesTypesTotal,
  getPurchasesTypesTotalSite,
  getPurchasesTypesTotalCategorySafeframe,
  getPurchasesTypesTotalSiteCategorySafeframe,
} from "@/services/singleCampaign/index";
import { getChartVerification } from "@/components/SingleCampaign/services";
import { getSensitiveUrl } from "@/services/singleCampaign/index";

const generalDatas = {
  namespaced: true,
  state: {
    purchasesTypes: null,
    purchasesTypesSafeframe: null,
    allChartVerification: null,
    sensitiveUrl: null

  },
  getters: {
    purchasesTypes: (state) => state.purchasesTypes,
    purchasesTypesSafeframe: (state) => state.purchasesTypesSafeframe,
    allChartVerification: (state) => state.allChartVerification,
    sensitiveUrl: (state) => state.sensitiveUrl,
  },
  mutations: {
    SET_PURCHASES_TYPES_TOTAL(state, payload) {
      state.purchasesTypes = payload;
    },
    SET_PURCHASES_TYPES_TOTAL_SAFEFRAME(state, payload) {
      state.purchasesTypesSafeframe = payload;
    },
    SET_CHART_VERIFICATION(state, payload) {
      state.allChartVerification = payload;
    },
    CLEAR_CHART_VERIFICATION(state, payload) {
      state.allChartVerification = null;
    },
    SET_SENSITIVE_URL(state, payload) {
      state.sensitiveUrl = payload;
    },
  },
  actions: {
    async purchasesTypesTotalSite({ commit }, variables) {
      const response = await getPurchasesTypesTotalSite(variables);
      commit("SET_PURCHASES_TYPES_TOTAL", response);
    },
    async purchasesTypesTotalSiteCategorySafeframe({ commit }, variables) {
      const response = await getPurchasesTypesTotalSiteCategorySafeframe(variables);
      commit("SET_PURCHASES_TYPES_TOTAL_SAFEFRAME", response);
    },
    async purchasesTypesTotal({ commit }, variables) {
      const response = await getPurchasesTypesTotal(variables);
      commit("SET_PURCHASES_TYPES_TOTAL", response);
    },
    async purchasesTypesTotalCategorySafeframe({ commit }, variables) {
      const response = await getPurchasesTypesTotalCategorySafeframe(variables);
      commit("SET_PURCHASES_TYPES_TOTAL_SAFEFRAME", response);
    },
    async chartVerificationTotal({ commit }, variables) {
      commit("SET_CHART_VERIFICATION", []);
      const response = await getChartVerification(variables);
      commit("SET_CHART_VERIFICATION", response);
    },
    async clearChartVerificationTotal({ commit }, variables) {
      commit("CLEAR_CHART_VERIFICATION",variables);
    },
    async sensitiveUrlTotal({ commit }, variables) {
      const response = await getSensitiveUrl(variables);
      commit("SET_SENSITIVE_URL", response);
    },
  },
};

export default generalDatas;
